import { createWithEqualityFn } from 'zustand/traditional'
import axios from 'axios'

interface GeoStore {
	provinces: any[]
	amphures: any[]
	tumbons: any[]
	setProvinces: (province: any) => void
	setAmphures: (amphures: any) => void
	setTumbons: (tumbons: any) => void
	getProvinces: () => Promise<{ success: boolean; data: any }>
	getAmphures: (provinceId: string) => Promise<{ success: boolean; data: any }>
	getTumbons: (amphureId: string) => Promise<{ success: boolean; data: any }>
	clearState: () => void
}

export const API_SLUG = 'geo'

export const useGeoStore = createWithEqualityFn<GeoStore>(
	set => ({
		provinces: [],
		amphures: [],
		tumbons: [],
		setProvinces: (province: any) => {
			set({ provinces: province })
		},
		setAmphures: (amphures: any) => {
			set({ amphures: amphures })
		},
		setTumbons: (tumbons: any) => {
			set({ tumbons: tumbons })
		},
		getProvinces: async () => {
			return axios
				.get(`/${API_SLUG}/provinces`)
				.then(res => {
					set({ provinces: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				})
		},
		getAmphures: async (provinceId: string) => {
			return axios
				.get(`/${API_SLUG}/provinces/${provinceId}/amphures`)
				.then(res => {
					set({ amphures: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				})
		},
		getTumbons: async (amphureId: string) => {
			return axios
				.get(`/${API_SLUG}/amphures/${amphureId}/tumbons`)
				.then(res => {
					set({ tumbons: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					return {
						success: false,
						data: err?.response?.data?.message?.toString(),
					}
				})
		},
		clearState: () => {
			set({
				provinces: [],
				amphures: [],
				tumbons: [],
			})
		},
	}),
	Object.is
)
